import logoPositions from "../styles/logoPositions";

export const items = [
  {
    name: 'CVC CREW',
    id: 6210,
    fabric: '60% Cotton / 40% Poly',
    fabricDetail: '60% Combed Ring-Spun Cotton 40% Polyester /32 singles, 145 grams/4.3oz',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'],
    defaultItem: {
      name: 'BLACK'
    },
    colors: [
      {
        name: 'BLACK',
        desc: 'Black',
        swatch: 'black',
      },
      {
        name: 'WHITE',
        desc: 'White',
        swatch: 'white',
      },
      {
        name: 'APPLE-GREEN',
        desc: 'Apple Green',
        swatch: 'apple-green',
      },
      {
        name: 'BANANACREAM',
        desc: 'Banana Cream',
        swatch: 'bananacream',
      },
      {
        name: 'BONDIBLUE',
        desc: 'Bondi Blue',
        swatch: 'bondi-blue',
      },
      {
        name: 'CARDINAL',
        desc: 'Cardinal',
        swatch: 'cardinal',
      },
      {
        name: 'CHARCOAL',
        desc: 'Charcoal',
        swatch: 'charcoal',
      },
      {
        name: 'CREAM',
        desc: 'Cream',
        swatch: 'cream',
      },
      {
        name: 'DARKHEATHERGRAY',
        desc: 'Dark Heather Gray',
        swatch: 'dark-heather-gray',
      },
      {
        name: 'ESPRESSO',
        desc: 'Espresso',
        swatch: 'espresso',
      },
      {
        name: 'HEATHER-COLUMBIA-BLUE',
        desc: 'Heather Columbia Blue',
        swatch: 'heather-columbia-blue',
      },
      {
        name: 'HEATHER-COOL-BLUE',
        desc: 'Heather Cool Blue',
        swatch: 'sueded-heather-cool-blue',
      },
      {
        name: 'HEATHER-FOREST-GREEN',
        desc: 'Heather Forest Green',
        swatch: 'sueded-heather-forest-green',
      },
      {
        name: 'HEATHER-MAROON',
        desc: 'Heather Maroon',
        swatch: 'sueded-heather-maroon',
      },
      {
        name: 'HEATHER-MAUVE',
        desc: 'Heather Mauve',
        swatch: 'heather-mauve',
      },
      {
        name: 'HEATHER-HEAVY-METAL',
        desc: 'Heather Metal',
        swatch: 'sueded-heather-metal',
      },
      {
        name: 'ICEBLUE',
        desc: 'Ice Blue',
        swatch: 'ice-blue',
      },
      {
        name: 'INDIGO',
        desc: 'Indigo',
        swatch: 'indigo',
      },
      {
        name: 'KELLYGREEN',
        desc: 'Kelly Green',
        swatch: 'kelly-green',
      },
      {
        name: 'LIGHTOLIVE',
        desc: 'Light Olive',
        swatch: 'lt-olive',
      },
      {
        name: 'MIDNIGHTNAVY',
        desc: 'Midnight Navy',
        swatch: 'midnight-navy',
      },
      {
        name: 'MILITARYGREEN',
        desc: 'Military Green',
        swatch: 'military-green',
      },
      {
        name: 'MINT',
        desc: 'Mint',
        swatch: 'mint',
      },
      {
        name: 'NEONHEATHERGREEN',
        desc: 'Neon Heather Green',
        swatch: 'neonheathergreen',
      },
      {
        name: 'NEONYELLOW',
        desc: 'Neon Yellow',
        swatch: 'nyl-yellow',
      },
      {
        name: 'ORANGE',
        desc: 'Orange',
        swatch: 'orange',
      },
      {
        name: 'PURPLERUSH',
        desc: 'Purple Rush',
        swatch: 'purplerush',
      },
      {
        name: 'RED',
        desc: 'Red',
        swatch: 'red',
      },
      {
        name: 'ROYAL',
        desc: 'Royal',
        swatch: 'royal',
      },
      {
        name: 'SAND',
        desc: 'Sand',
        swatch: 'sand',
      },
      {
        name: 'SILK',
        desc: 'Silk',
        swatch: 'silk',
      },
      {
        name: 'STONEGRAY',
        desc: 'Stone Gray',
        swatch: 'stone-gray',
      },
      {
        name: 'STORM',
        desc: 'Storm',
        swatch: 'storm',
      },
      {
        name: 'TAHITIBLUE',
        desc: 'Tahiti Blue',
        swatch: 'tahiti-blue',
      },
      {
        name: 'TEAL',
        desc: 'Teal',
        swatch: 'teal',
      },
      {
        name: 'TURQUOISE',
        desc: 'Turquoise',
        swatch: 'turquoise',
      },
      {
        name: 'WARMGRAY',
        desc: 'Warm Gray',
        swatch: 'warm-gray',
      },
    ]
  },
  {
    name: 'POLY/COTTON CREW',
    id: 6200,
    fabric: '35% Cotton / 65% Poly',
    fabricDetail: '65% Polyester 35% Combed Ring-Spun Cotton / 40 singles, 120 grams/3.5 oz.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
    defaultItem: {
      name: 'BLACK'
    },
    colors: [
      {
        name: 'BLACK',
        desc: 'Black',
        swatch: 'black',
      },
      {
        name: 'WHITE',
        desc: 'White',
        swatch: 'white',
      },
      {
        name: 'ANTIQUEDENIM',
        desc: 'Antique Denim',
        swatch: 'antiquedenim',
      },
      {
        name: 'ANTIQUEGOLD',
        desc: 'Antique Gold',
        swatch: 'festival-antiquegold',
      },
      {
        name: 'ASH',
        desc: 'Ash',
        swatch: 'ash',
      },
      {
        name: 'CHARCOAL',
        desc: 'Charcoal',
        swatch: 'charcoal',
      },
      {
        name: 'ENVY',
        desc: 'Envy',
        swatch: 'envy',
      },
      {
        name: 'ESPRESSO',
        desc: 'Espresso',
        swatch: 'espresso',
      },
      {
        name: 'INDIGO',
        desc: 'Indigo',
        swatch: 'indigo',
      },
      {
        name: 'RED',
        desc: 'Red',
        swatch: 'red',
      },
      {
        name: 'ROYAL',
        desc: 'Royal',
        swatch: 'royal',
      },
      {
        name: 'ROYALPINE',
        desc: 'Royal Pine',
        swatch: 'festival-royalpine',
      },
      {
        name: 'SAGE',
        desc: 'Sage',
        swatch: 'sage',
      },
      {
        name: 'SHIRAZ',
        desc: 'Shiraz',
        swatch: 'festival-shiraz',
      },
      {
        name: 'SILVER',
        desc: 'Silver',
        swatch: 'silver',
      },
      {
        name: 'SMOKEDPAPRIKA',
        desc: 'Smoked Paprika',
        swatch: 'festival-smokedpaprika',
      },
      {
        name: 'STONEWASHDENIM',
        desc: 'Stonewash Denim',
        swatch: 'stone-wash',
      },
      {
        name: 'STONEWASHGREEN',
        desc: 'Stonewash Green',
        swatch: 'festival-stonewashgreen',
      }
    ]
  },
  {
    name: 'PCH PULLOVER HOODY',
    id: 9300,
    fabric: '60% Cotton / 40% Poly Fleece',
    fabricDetail: '60% Cotton 40% Polyester Fleece / 30 singles, 250 grams/7.4oz heathered fleece, 60/40 CVC face.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
    style: logoPositions[9300],
    defaultItem: {
      name: 'HEATHERBLACK'
    },
    colors: [
      {
        name: 'HEATHERBLACK',
        desc: 'Heather Black',
        swatch: 'black',
      },
      {
        name: 'HEATHERBAYBLUE',
        desc: 'Heather Bay Blue',
        swatch: 'heatherbayblue',
      },
      {
        name: 'CARDINAL',
        desc: 'Heather Cardinal',
        swatch: 'cardinal',
      },
      {
        name: 'HEATHERGRAY',
        desc: 'Heather Gray',
        swatch: 'heather-gray',
      },
      {
        name: 'HEATHERMAROON',
        desc: 'Heather Maroon',
        swatch: 'heathermaroon',
      },
      {
        name: 'MIDNIGHTNAVY',
        desc: 'Heather Midnight Navy',
        swatch: 'midnight-navy',
      },
      {
        name: 'HEATHERMILITARYGREEN',
        desc: 'Heather Military Green',
        swatch: 'heathermilitarygreen',
      },
      {
        name: 'HEATHERSLATEBLUE',
        desc: 'Heather Slate Blue',
        swatch: 'heather-slate-blue',
      },
      {
        name: 'HEATHERTEAL',
        desc: 'Heather Teal',
        swatch: 'heatherteal',
      },
      {
        name: 'OATMEAL',
        desc: 'Oatmeal',
        swatch: 'oatmeal',
      }
    ]
  },
  // {
  //   name: 'TRI-BLEND L/S HOODY',
  //   id: 6021,
  //   fabric: '50/25/25 Poly/Cotton/Rayon',
  //   fabricDetail: '50% Polyester 25% Combed Ring-Spun Cotton 25% Rayon / 32 singles, 145 grams/4.3oz.',
  //   sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
  //   style: logoPositions[6021],
  //   defaultItem: {
  //     name: 'VINTAGEBLACK'
  //   },
  //   colors: [
  //     {
  //       name: 'HEATHERWHITE',
  //       desc: 'Heather White',
  //       swatch: 'heather-white',
  //     },
  //     {
  //       name: 'VINTAGEBLACK',
  //       desc: 'Vintage Black',
  //       swatch: 'vintage-black',
  //     },
  //     {
  //       name: 'ENVY',
  //       desc: 'Envy',
  //       swatch: 'envy',
  //     },
  //     {
  //       name: 'INDIGO',
  //       desc: 'Indigo',
  //       swatch: 'indigo',
  //     },
  //     {
  //       name: 'MACCHIATO',
  //       desc: 'Macchiato',
  //       swatch: 'macchiato',
  //     },
  //     {
  //       name: 'MILITARYGREEN',
  //       desc: 'Military Green',
  //       swatch: 'military-green',
  //     },
  //     {
  //       name: 'PREMIUMHEATHER',
  //       desc: 'Prem Heather',
  //       swatch: 'premheather',
  //     },
  //     {
  //       name: 'PURPLERUSH',
  //       desc: 'Purple Rush',
  //       swatch: 'purplerush',
  //     },
  //     {
  //       name: 'TAHITIBLUE',
  //       desc: 'Tahiti Blue',
  //       swatch: 'tahiti-blue',
  //     },
  //     {
  //       name: 'VENETIANGRAY',
  //       desc: 'Venetian Gray',
  //       swatch: 'venetiangray',
  //     },
  //     {
  //       name: 'VINTAGENAVY',
  //       desc: 'Vintage Navy',
  //       swatch: 'vintage-navy',
  //     },
  //     {
  //       name: 'VINTAGEPURPLE',
  //       desc: 'Vintage Purple',
  //       swatch: 'vintage-purple',
  //     },
  //     {
  //       name: 'VINTAGERED',
  //       desc: 'Vintage Red',
  //       swatch: 'vintage-red',
  //     },
  //     {
  //       name: 'VINTAGEROYAL',
  //       desc: 'Vintage Royal',
  //       swatch: 'vintage-royal',
  //     },
  //     {
  //       name: 'VINTAGETURQUOISE',
  //       desc: 'Turquoise',
  //       swatch: 'vintage-turquoise',
  //     }
  //   ]
  // },
  // {
  //   name: 'MOCK TWIST RAGLAN HOODY',
  //   id: 2021,
  //   fabric: '60% Cotton / 40% Poly',
  //   fabricDetail: '60% Combed Ring-Spun Cotton 40% Polyester / 20 singles, 175 grams/5.1oz.',
  //   sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
  //   defaultItem: {
  //     name: 'BLACK'
  //   },
  //   colors: [
  //     {
  //       name: 'BLACK',
  //       desc: 'Black',
  //       swatch: 'mocktwist-black',
  //     },
  //     {
  //       name: 'FORESTGREEN',
  //       desc: 'Forest Green',
  //       swatch: 'mocktwist-forest-green',
  //     },
  //     {
  //       name: 'HEATHERGRAY',
  //       desc: 'Heather Gray',
  //       swatch: 'mocktwist-heathergray',
  //     },
  //     {
  //       name: 'INDIGO',
  //       desc: 'Indigo',
  //       swatch: 'mocktwist-indigo',
  //     },
  //     {
  //       name: 'LIGHTMAROON',
  //       desc: 'Light Maroon',
  //       swatch: 'mocktwist-lightmaroon',
  //     },
  //     {
  //       name: 'TECHPINK',
  //       desc: 'Tech Pink',
  //       swatch: 'mocktwist-techpink',
  //     }
  //   ]
  // },
  {
    name: 'DISTRICT LONG SLEEVE HOODIE',
    id: 8070,
    fabric: '50% Poly / 25% Cotton / 25% Rayon',
    fabricDetail: '4.5-ounce, 50/25/25 poly/combed ring spun cotton/rayon, 32 singles',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'],
    style: logoPositions[8070],
    defaultItem: {
      name: 'BLACKFROST'
    },
    colors: [
      {
        name: 'BLACKFROST',
        desc: 'Black Frost',
        swatch: 'black-frost',
      },
      {
        name: 'CHARCOAL',
        desc: 'Charcoal',
        swatch: 'charcoal',
      },
      {
        name: 'DEEPROYAL',
        desc: 'Deep Royal',
        swatch: 'deep-royal',
      },
      {
        name: 'GREYFROST',
        desc: 'Grey Frost',
        swatch: 'grey-frost',
      },
      {
        name: 'NAVYFROST',
        desc: 'Navy Frost',
        swatch: 'navy-frost',
      }
    ]
  },
  {
    name: 'WOMEN\'S IDEAL RACERBACK TANK',
    id: 1533,
    style: logoPositions.tank1,
    fabric: '60% Cotton / 40% Poly',
    fabricDetail: '60% Combed Ring-Spun Cotton 40% Polyester / 30 singles, 135 grams/4.0oz',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    defaultItem: {
      name: 'BLACK'
    },
    colors: [
      {
        name: 'BLACK',
        desc: 'Black',
        swatch: 'black',
      },
      {
        name: 'WHITE',
        desc: 'White',
        swatch: 'white',
      },
      {
        name: 'ANTIQUEGOLD',
        desc: 'Antique Gold',
        swatch: 'festival-antiquegold',
      },
      {
        name: 'BANANACREAM',
        desc: 'Banana Cream',
        swatch: 'bananacream',
      },
      {
        name: 'CANCUN',
        desc: 'Cancun',
        swatch: 'cancun',
      },
      {
        name: 'CARDINAL',
        desc: 'Cardinal',
        swatch: 'cardinal',
      },
      {
        name: 'DESERTPINK',
        desc: 'Desert Pink',
        swatch: 'festival-desertpink',
      },
      {
        name: 'DARKGRAY',
        desc: 'Dark Gray',
        swatch: 'darkgray',
      },
      {
        name: 'HEATHERGRAY',
        desc: 'Heather Gray',
        swatch: 'heather-gray',
      },
      {
        name: 'HOTPINK',
        desc: 'Hot Pink',
        swatch: 'hotpink',
      },
      {
        name: 'INDIGO',
        desc: 'Indigo',
        swatch: 'indigo',
      },
      {
        name: 'KELLYGREEN',
        desc: 'Kelly Green',
        swatch: 'kelly-green',
      },
      {
        name: 'LIGHTORANGE',
        desc: 'Light Orange',
        swatch: 'light-orange',
      },
      {
        name: 'LILAC',
        desc: 'Lilac',
        swatch: 'lilac',
      },
      {
        name: 'MIDNIGHTNAVY',
        desc: 'Midnight Navy',
        swatch: 'midnight-navy',
      },
      {
        name: 'MILITARYGREEN',
        desc: 'Military Green',
        swatch: 'military-green',
      },
      {
        name: 'MINT',
        desc: 'Mint',
        swatch: 'mint',
      },
      {
        name: 'PURPLERUSH',
        desc: 'Purple Rush',
        swatch: 'purplerush',
      },
      {
        name: 'RASPBERRY',
        desc: 'Raspberry',
        swatch: 'raspberry',
      },
      {
        name: 'RED',
        desc: 'Red',
        swatch: 'red',
      },
      {
        name: 'ROYAL',
        desc: 'Royal',
        swatch: 'royal',
      },
      {
        name: 'SILVER',
        desc: 'Silver',
        swatch: 'silver',
      },
      {
        name: 'TAHITIBLUE',
        desc: 'Tahiti Blue',
        swatch: 'tahiti-blue',
      },
      {
        name: 'TURQUOISE',
        desc: 'Turquoise',
        swatch: 'turquoise',
      },
      {
        name: 'WARMGRAY',
        desc: 'Warm Gray',
        swatch: 'warm-gray',
      },
    ]
  },
  {
    name: 'WOMEN\'S FESTIVAL TANK',
    id: 5033,
    fabric: '35% Cotton / 65% Poly',
    fabricDetail: '65% Polyester 35% Combed Ring-Spun Cotton / 40 singles, 120 grams/3.5 oz.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    style: logoPositions[5033],
    defaultItem: {
      name: 'BLACK'
    },
    colors: [
      {
        name: 'BLACK',
        desc: 'Black',
        swatch: 'black',
      },
      {
        name: 'WHITE',
        desc: 'White',
        swatch: 'white',
      },
      {
        name: 'ANTIQUEDENIM',
        desc: 'Antique Denim',
        swatch: 'antiquedenim',
      },
      {
        name: 'ANTIQUEGOLD',
        desc: 'Antique Gold',
        swatch: 'festival-antiquegold',
      },
      {
        name: 'ASH',
        desc: 'Ash',
        swatch: 'ash',
      },
      {
        name: 'CHARCOAL',
        desc: 'Charcoal',
        swatch: 'charcoal',
      },
      {
        name: 'DESERTPINK',
        desc: 'Desert Pink',
        swatch: 'festival-desertpink',
      },
      {
        name: 'RED',
        desc: 'Red',
        swatch: 'red',
      },
      {
        name: 'ROYAL',
        desc: 'Royal',
        swatch: 'royal',
      },
      {
        name: 'ROYALPINE',
        desc: 'Royal Pine',
        swatch: 'festival-royalpine',
      },
      {
        name: 'SHIRAZ',
        desc: 'Shiraz',
        swatch: 'festival-shiraz',
      },
      {
        name: 'SILVER',
        desc: 'Silver',
        swatch: 'silver',
      },
      {
        name: 'SMOKEDPAPRIKA',
        desc: 'Smoked Paprika',
        swatch: 'festival-smokedpaprika',
      },
      {
        name: 'STONEWASHDENIM',
        desc: 'Stonewash Denim',
        swatch: 'stone-wash',
      },
      {
        name: 'STONEWASHGREEN',
        desc: 'Stonewash Green',
        swatch: 'festival-stonewashgreen',
      }
    ]
  },
]

export default items;